import './DataGridContextMenuItem.afbbf1acad19080b7ba0151341125d6f.css';
export default {"menuItem":"_menuItem_j9yor_1","disabled":"_disabled_j9yor_1"};